import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import QueryString from 'query-string';

export default function NoAuthRoute({ component, ...rest }) {
  const location = useLocation();
  const queryParams = QueryString.parse(location.search);
  const user = useSelector((state) => state.user.loggedUser);
  const Component = component;

  if (user && rest.path !== '/reset-password/:token') {
    if (queryParams.referer) {
      window.location = queryParams.referer;
      return null;
    }
    return <Navigate to='/' />;
  }

  return (
    <Component {...rest} />
  );
}
